import { Component, OnInit, Input,Inject,ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { AccountService, InstoreService } from '@app/_services';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Renderer2 } from '@angular/core';
import { Router, NavigationExtras} from "@angular/router"
import { first } from 'rxjs/operators';
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExcelService } from '@app/_services/excel.service';
import { Excel_InstoreExport,Excel_HoardingExport } from '@app/_services/Instore'; // './././_services/Instore';
import {Sort} from '@angular/material/sort';
declare var $:any;

import pdfMake from "pdfmake/build/pdfmake";  
import pdfFonts from "pdfmake/build/vfs_fonts";  
pdfMake.vfs = pdfFonts.pdfMake.vfs; 

import * as moment from 'moment'; 
import jsPDF from 'jspdf'
import autoTable, { Row } from 'jspdf-autotable'


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  @ViewChild('pdfTable') pdfTable: ElementRef;

  isChecked = false;

  private format = 'YYYY-MM-DD';
  form: UntypedFormGroup;

  page = 1;
  pageSize = 10;
  isLoading = false;
  AssetsDataLists;
  CreativeDataLists;
  RegionDataLists;
  ShowroomDataLists;
  VendorDataLists;

  InstoreLists;
  CampaignLists;
  HoardingLists;

  filterInstoreLists;

  excel_InstoreExport: Excel_InstoreExport[] = [];
  excel_HoardingExport: Excel_HoardingExport[] = [];

  selRegionValue: number;

  selModule = 1;

  selCreativeValue = -1;
  selAssetTypeValue = -1;
  selVendorValue = -1;
  selInstallDate_Start = "";
  selInstallDate_End = "";
  selExpiryDate_Start = "";
  selExpiryDate_End="";
  user_role_id:number;
  user_region_id: number=0;
  user_showroom_id: number=0;

  regionName: string=""
  showroomName: string=""

  is_Admin_User:boolean = true;

  selectedShowroomIds = [];
  selectedAssetIDs = [];
  selectedCreativeIds =[];
  selectedVendorIds =[];
  dropdownSettings:IDropdownSettings;
  FilterShowroomLists;

  term: string;

  constructor(private formBuilder: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,private modalService: NgbModal,
    private accountService: AccountService,
    private instoreService: InstoreService,private excelService:ExcelService,
    private router: Router,
    private renderer: Renderer2) {
  }

  ngOnInit(): void {

    var userdata = localStorage.getItem('userInformation');
    var _data = JSON.parse(userdata);
    if(_data) {
      this.user_role_id = _data.role_id;
      this.user_region_id = _data.region_id;
      this.user_showroom_id = _data.showroom_id;
      this.regionName = _data.region_name;
      this.showroomName = _data.showroom_name;
      
      if(this.user_role_id==1 || this.user_role_id == 2){
        this.is_Admin_User = true
      }else{
        this.is_Admin_User = false;
      }
    }


    this.form = this.formBuilder.group({
      location_id: ['', Validators.required], //m
      particulars: ['', Validators.required], //m
      region_id: ['', Validators.required], //m
      showroom_id: ['', Validators.required], //m
    });
    
    this.form = this.formBuilder.group({
      region_id: [''],
      include: [''],
      search: [''],
      showroom_id: [''],
      asset_type_id: [''],
      creative_id: [''], 
      vendor_id: [''],
      installation_date_start: [''],
      installation_date_end:[''],
      expiry_date_start: [''],
      expiry_date_end: ['']
    });



    this.reloadRegionLists();
    this.reloadShowroomLists();
    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadVendorLists();
    this.loadInstoreData();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
   }



  }
  clearFilters() {
    this.form.get("region_id").setValue("");
    this.form.get("showroom_id").setValue("");
    this.form.get("asset_type_id").setValue([]);
    this.form.get("creative_id").setValue([]);
    this.form.get("vendor_id").setValue([]);
    this.form.get("search").setValue('');
    this.form.get("installation_date_start").setValue("");
    this.form.get("installation_date_end").setValue("");
    this.form.get("expiry_date_start").setValue("");
    this.form.get("expiry_date_end").setValue("");
    this.selRegionValue = 0;
    this.selInstallDate_Start = "";
    this.selInstallDate_End = "";
    this.selExpiryDate_Start = "";
    this.selExpiryDate_End = "";
    this.selectedShowroomIds=[];
    this.selectedAssetIDs = [];
    this.selectedCreativeIds =[];
    this.selectedVendorIds =[];
    this.term = "";
    this.filterReport();

  }

  
  fileName= 'ExcelSheet.xlsx'; 


  installChange(event) {
    if(event.value){
      this.selInstallDate_Start =  moment(event.value).format(this.format);
    } else {
      this.selInstallDate_Start = "";
    }
    this.filterReport();
  } 
  installChangeEnd(event) {
    if(event.value){
      this.selInstallDate_End =  moment(event.value).format(this.format);
    } else {
      this.selInstallDate_End = "";
    }
    this.filterReport();
  } 


  expiryChange(event) {
    if(event.value){
      //console.log("Date of Birth: " + moment(event.value).format(this.format) );
      this.selExpiryDate_Start =  moment(event.value).format(this.format);
    } else {
      this.selExpiryDate_Start = "";
    }
    this.filterReport();
  } 

  expiryChangeEnd(event) {
    if(event.value){
      //console.log("Date of Birth: " + moment(event.value).format(this.format) );
      this.selExpiryDate_End =  moment(event.value).format(this.format);
    } else {
      this.selExpiryDate_End = "";
    }
    this.filterReport();
  }


  InstoreHoardingData = "";
  open(content,InstoreHoardingData:any) {
    this.InstoreHoardingData = InstoreHoardingData;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size:'lg'}).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  onRegionChange(regionValue) {
    this.selRegionValue =  parseInt(regionValue, 10);
    this.resetShowroom();
    this.FilterShowroomLists = this.ShowroomDataLists.filter(s => s.region_id === this.selRegionValue);
    this.filterReport();

    // if(!this.is_Admin_User){
    //   this.form.controls.showroom_id.setValue(this.user_showroom_id);
    //   this.form.get('showroom_id').disable();
    // }
  }
  resetShowroom() {
  this.form.patchValue({
    showroom_id: ''
  });
  }
  onShowroomItemSelect(item: any) {
    // console.log(item)
    this.selectedShowroomIds.push(item.id);
    this.filterReport()
  }
  onShowroomSelectAll() {
    this.selectedShowroomIds = this.FilterShowroomLists.map(x => x.id);
    this.selectedShowroomIds = this.selectedShowroomIds.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterReport()
  }
  onShowroomDeSelectAll() {
    this.selectedShowroomIds = [];
    this.filterReport()
  }
  onShowroomItemDeSelect(item: any) {
      this.selectedShowroomIds.forEach((value,index)=>{
      if(value==item.id) this.selectedShowroomIds.splice(index,1);
    });
    this.filterReport()
  }



  onItemSelect(item: any) {
    // console.log(item)
    this.selectedAssetIDs.push(item.id);
    this.filterReport()
  }
  onSelectAll() {
    this.selectedAssetIDs = this.AssetsDataLists.map(x => x.id);
    this.selectedAssetIDs = this.selectedAssetIDs.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterReport()
  }
  onDeSelectAll() {
    this.selectedAssetIDs = [];
    this.filterReport()
  }
  onItemDeSelect(item: any) {
      this.selectedAssetIDs.forEach((value,index)=>{
      if(value==item.id) this.selectedAssetIDs.splice(index,1);
    });
    this.filterReport()
  }

  
  onCreativeItemSelect(item: any) {
    console.log(item)
    this.selectedCreativeIds.push(item.id);
    this.filterReport()
  }
  onCreativeSelectAll() {
    this.selectedCreativeIds = this.CreativeDataLists.map(x => x.id);
    this.selectedCreativeIds = this.selectedCreativeIds.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })
    this.filterReport()
  }
  onCreativeDeSelectAll() {
    this.selectedCreativeIds = [];
    this.filterReport()
  }
  onCreativeItemDeSelect(item: any) {
    this.selectedCreativeIds.forEach((value,index)=>{
      if(value==item.id) this.selectedCreativeIds.splice(index,1);
    });

    this.filterReport()
  }


  onVendorItemSelect(item: any) {
    console.log(item)
    this.selectedVendorIds.push(item.id);
    this.filterReport()
  }
  onVendorSelectAll() {
    this.selectedVendorIds = this.VendorDataLists.map(x => x.id);
    this.selectedVendorIds = this.selectedVendorIds.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
    })  
  }
  onVendorDeSelectAll() {
    this.selectedVendorIds = [];
    this.filterReport()
  }
  onVendorItemDeSelect(item: any) {
    this.selectedVendorIds.forEach((value,index)=>{
      if(value==item.id) this.selectedVendorIds.splice(index,1);
    });

    this.filterReport()
  }

  filterReport(){
     var globalList;
      if(this.selModule == 1) {
        globalList = this.InstoreLists;
      }  
      else if(this.selModule == 2) {
        globalList = this.CampaignLists;
      }
      else if(this.selModule == 3) {
        globalList = this.HoardingLists;
      }

     
      globalList = globalList.filter((item) => {
        var isDiscontinued = true;
        var typeRegion = true;
        var installCondition_Start = true;
        var installCondition_End = true;
        var expiryCondition_Start = true;
        var expiryCondition_End = true;
        if(!this.isChecked){
            isDiscontinued =(item.is_discontinued === 0)
        }
        if(this.selRegionValue > 0) {
            typeRegion = (item.region_id == this.selRegionValue);
        }
        if(this.selInstallDate_Start != "") {
           installCondition_Start = (item.install_date >= this.selInstallDate_Start);
        } 
        if(this.selInstallDate_End != "") {
          installCondition_End = (item.install_date <= this.selInstallDate_End);
        } 
        
        if(this.selExpiryDate_Start != "") {
          expiryCondition_Start = (item.expiry_date >= this.selExpiryDate_Start);
        }
         if(this.selExpiryDate_End != "") {
          expiryCondition_End = (item.expiry_date <= this.selExpiryDate_End);
        }
        return isDiscontinued&&typeRegion&&installCondition_Start && installCondition_End && expiryCondition_Start && expiryCondition_End;
      });


      if(this.selectedAssetIDs.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
          this.filterInstoreLists = [
            ...globalList.filter(x => this.selectedAssetIDs.includes(x.asset_type_id))
      ];
      }else if(this.selectedAssetIDs.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
          this.filterInstoreLists = [
              ...globalList.filter(x => this.selectedCreativeIds.includes(x.creative_id))
        ];
      }else if(this.selectedAssetIDs.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
          this.filterInstoreLists = [
              ...globalList.filter(x => this.selectedVendorIds.includes(x.vendor_id))
        ];
      }


      else if(this.selectedAssetIDs.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
      this.filterInstoreLists = [
        ...globalList.filter(x => this.selectedAssetIDs.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
      ];
      }else if(this.selectedAssetIDs.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
        this.filterInstoreLists = [
          ...globalList.filter(x => this.selectedAssetIDs.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
        ];
      }else if(this.selectedAssetIDs.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
        this.filterInstoreLists = [
          ...globalList.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
        ];
      }



      else if(this.selectedAssetIDs.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
          this.filterInstoreLists = [...globalList];
      }else{
          this.filterInstoreLists = [
            ...globalList.filter(x => this.selectedAssetIDs.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
          ];
      }

      if(this.selectedShowroomIds.length==0){
        this.filterInstoreLists = [...this.filterInstoreLists];
      }else{
          this.filterInstoreLists = [
            ...this.filterInstoreLists.filter(x => this.selectedShowroomIds.includes(x.showroom_id))
          ];
      }

      this.excel_InstoreExport=[];
      this.excel_HoardingExport=[];
  }

      sortData(sort: Sort) {
          const data = this.filterInstoreLists.slice();
          if (!sort.active || sort.direction == '') {
            this.filterInstoreLists = data;
            return;
          }
          
          this.filterInstoreLists = data.sort((a, b) => {
            let isAsc = sort.direction == 'asc';
            switch (sort.active) {
              // case 'expiryDays': return this.instoreService.compare(a.expiryDays, b.expiryDays, isAsc);
              case 'regionName': return this.instoreService.compare(a.regionName, b.regionName, isAsc);
              case 'showroomName': return this.instoreService.compare(a.showroomName, b.showroomName, isAsc);
              case 'assetTypeName': return this.accountService.compare(a.assetTypeName, b.assetTypeName, isAsc);
              case 'creativeName': return this.instoreService.compare(a.creativeName, b.creativeName, isAsc);
              case 'vendorName': return this.instoreService.compare(a.vendorName, b.vendorName, isAsc);
              case 'floorName': return this.instoreService.compare(a.floorName, b.floorName, isAsc);
              case 'expiryDays': return this.instoreService.compare(a.expiryDays, b.expiryDays, isAsc);
              
              default: return 0;
            }
          });
     }

    checkValue(){
        this.filterReport();
    }

    restoreInstore(id){
      this.isLoading = true;
      this.instoreService.restoreInstore(id)
      .pipe(first())
        .subscribe(
        (response) => {
        this.isLoading = false;
        this.loadInstoreData();
        },
      (error) => {     
        this.isLoading = false;                               
      }
      );
    }
    
  restoreHoarding(id){
    this.isLoading = true;
    this.instoreService.restoreHoarding(id)
    .pipe(first())
      .subscribe(
      (response) => {
       this.isLoading = false;
       this.loadHoardingData();
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  loadInstoreData() {
    this.isLoading = true;
    this.instoreService.getInstoreLists(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        //this.AssetsDataLists = response.result;
        // this.clearFilter()
        this.InstoreLists = response.result;
        console.log("---"+JSON.stringify(this.InstoreLists));
        this.filterInstoreLists = this.InstoreLists;
        this.filterReport();
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  } 


  loadHoardingData() {
    this.isLoading = true;
    this.instoreService.getHoardingLists(this.user_showroom_id)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        //this.AssetsDataLists = response.result
        // this.clearFilter()
        this.HoardingLists = response.result;
        this.filterInstoreLists = this.HoardingLists;
        this.filterReport();
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  changeInstore(e) {
    console.log("Instore "+e.target.value);
    this.selModule = 1;
    this.loadInstoreData()
  }

  // changeCampaign(e) {
  //   console.log("changeCampaign "+e.target.value);
  //   this.selModule = 2;
  //   this.loadCampaignData()
  // }

  changeHoarding(e) {
    console.log("changeHoarding "+e.target.value);
    this.selModule = 3;
    this.loadHoardingData()
  }
  exportexcel() {   
        if(this.selModule==1){
          for(var i=0; i<this.filterInstoreLists.length;i++) {
            var tempImport = this.filterInstoreLists[i];
            let tempInstore = {
              REGION:tempImport.regionName,
              SHOWROOM:tempImport.showroomName,
              FLOOR:tempImport.floorName,
              LOCATION:tempImport.locationName,
              TYPE:tempImport.assetTypeName,
              CREATIVE:tempImport.creativeName,
              PARTICULARS:tempImport.particulars,
              WIDTH:tempImport.size_w,
              HEIGHT:tempImport.size_h,
              NAME:tempImport.name,
              VENDOR:tempImport.vendorName,
              INSTALLATION_DATE:tempImport.install_date,
              EXPIRY_DATE:tempImport.expiry_date,
              IMAGE:tempImport.image,
              EXPIRY_DAYS:tempImport.expiryDays,
            };   
             this.excel_InstoreExport.push(tempInstore);
           }
          this.excelService.exportAsExcelFile( this.excel_InstoreExport, 'Instore');
        }else{
          for(var i=0; i<this.filterInstoreLists.length;i++) {
              var tempImport = this.filterInstoreLists[i];
              let tempHoarding = {
                REGION:tempImport.regionName,
                SHOWROOM:tempImport.showroomName,
                AREA:tempImport.area,
                TYPE:tempImport.assetTypeName,
                CREATIVE:tempImport.creativeName,
                PARTICULARS:tempImport.particulars,
                WIDTH:tempImport.size_w,
                HEIGHT:tempImport.size_h,
                COST:tempImport.cost,
                NAME:tempImport.name,
                VENDOR:tempImport.vendorName,
                INSTALLATION_DATE:tempImport.install_date,
                EXPIRY_DATE:tempImport.expiry_date,
                ADDRESS:tempImport.address,
                IMAGE:tempImport.image,
                EXPIRY_DAYS:tempImport.expiryDays,
            };   
            this.excel_HoardingExport.push(tempHoarding);
          }
         this.excelService.exportAsExcelFile( this.excel_HoardingExport, 'Hoardings');
        }
    }

  //PDF genrate button click function
  public downloadAsPDF() {

    const doc = new jsPDF('l', 'mm', 'a4'); 
    doc.setFontSize(9);
    if(this.selModule==1){
        const headInstore = [["REGION", "SHOWROOM","FLOOR","LOCATION","TYPE","CREATIVE","PARTICULARS","WIDTH"
                ,"HEIGHT","NAME","VENDOR","INSTALL DATE","EXPIRY DATE","IMAGE","EXPIRY DAYS"]];
        const dataInstore = []
        this.filterInstoreLists.forEach(element => {      
              var temp = [element.regionName,element.showroomName,
                element.floorName,element.locationName,
                element.assetTypeName,element.creativeName,
                element.particulars, this.splitNumber(element.size_w),
                this.splitNumber(element.size_h),element.name,
                element.vendorName,element.install_date,
                element.expiry_date,element.image,element.expiryDays]
                dataInstore.push(temp);

          });   

          autoTable(doc, {
            columnStyles: {
              6: {cellWidth: 30},
              13:{cellWidth: 30},
            },
            tableLineColor: [200, 200, 200],
            tableLineWidth: 0.05,
      
            margin: { top: 10, left: 8, right: 8, bottom: 10 },
            headStyles: {
              fontSize: 8,
              fontStyle:'bold',
              halign: 'center',
              valign: 'middle',
              lineColor:[255, 255, 255],
              lineWidth:0.05
            },
            bodyStyles:{
              fontSize: 9,
              halign: 'center',
              valign: 'middle',
              lineColor:[200, 200, 200],
              lineWidth:0.05
            },
                head: headInstore,
                body: dataInstore,
                didDrawCell: (data) => { },
            });
            window.open(doc.output('bloburl'), '_blank');
            doc.save('Instore'+ '_export_' + new Date().getTime()+'.pdf');

    }else{
      const headHoardings = [["REGION", "SHOWROOM","AREA","TYPE","CREATIVE","PARTICULARS","WIDTH"
      ,"HEIGHT","COST","NAME","VENDOR","INSTALL DATE","EXPIRY DATE","ADDRESS","IMAGE","EXPIRY DAYS"]];
        const dataHoardings = []

        this.filterInstoreLists.forEach(element => {      
            var temp = [element.regionName,element.showroomName,
              element.area,
              element.assetTypeName,element.creativeName,
              element.particulars, this.splitNumber(element.size_w),
              this.splitNumber(element.size_h),element.cost,element.name,
              element.vendorName,element.install_date,
              element.expiry_date,element.address,element.image,element.expiryDays]
              dataHoardings.push(temp);

        });  
        autoTable(doc, {
          columnStyles: {
            5: {cellWidth: 30},
            13:{cellWidth: 30},
          },
          tableLineColor: [200, 200, 200],
          tableLineWidth: 0.1,
    
          margin: { top: 10, left: 8, right: 8, bottom: 10 },
          headStyles: {
            fontSize: 7,
            fontStyle:'bold',
            halign: 'center',
            valign: 'middle',
            lineColor:[255, 255, 255],
            lineWidth:0.05
          },
          bodyStyles:{
            fontSize: 8,
            halign: 'center',
            valign: 'middle',
            lineColor:[200, 200, 200],
            lineWidth:0.05
          },
              head: headHoardings,
              body: dataHoardings,
              didDrawCell: (data) => { },
          }); 
          window.open(doc.output('bloburl'), '_blank');
          doc.save('Hoardings'+ '_export_' + new Date().getTime()+'.pdf');
        };
   
  
  }

  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
    
  }
  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  getColor(days:number): string {
    if(0 >= days) 
      return 'red';
    if(days>=1 && days <=10)
      return '#DA8C10';
  }
  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }
      return Math.round(value * 100) / 100+"'";
    }
  }
}


